import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { calculateDateRange, filterDataByTimeRange, checkScheduleHourHide } from '@/store/modules/calendar';
import moment from 'moment';
import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'customs_calendar';

// 近三天日程数据处理
const extractDataForDateRange = (originSchedule, date) => {
	const range = calculateDateRange(date, 'day');
	const rangeResult = filterDataByTimeRange(range, originSchedule);
	if (!rangeResult) return [];
	return rangeResult;
};
const generateLimitedDisplayData = (originSchedule, date) => {
	if (!originSchedule.length) return [];
	return extractDataForDateRange(originSchedule, date).slice(0, 3);
};
const formatDateFn = data => {
	const { scheduleStartTime, scheduleEndTime } = data;
	const disVisibleHour = checkScheduleHourHide(data);
	if (disVisibleHour) {
		return moment(scheduleStartTime).format('YYYY-MM-DD');
	}
	return `${moment(scheduleStartTime).format('YYYY-MM-DD HH:mm')} - ${moment(scheduleEndTime).format('HH:mm')}`;
};

// 默认上下文
function buildBaseCtx() {
	return {
		extractDataForDateRange,
		generateLimitedDisplayData,
		formatDateFn
	};
}

// 创建模块上下文系统
const { provide, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

function provideCurrentContext(overrides = {}) {
	// 子组件需要用到配置项 统一派发
	const { config, loadModuleConfig } = useModuleConfig();
	loadModuleConfig('customs_calendar');

	const _overrides = {
		calendarConfig: config,
		...overrides
	};
	return provide(_overrides);
}

export { provideCurrentContext, useCurrentContext };
